// Display · Eyebrow
//
// Uppercase, letter-spaced, muted-color label rendered above a value or section.
// Composes `TextValue` with the eyebrow preset (uppercase + semibold + muted)
// plus an optional leading icon via `Inline`.

import type { ReactNode } from "react";
import { Inline } from "@ds/layout/Inline";
import { TextValue } from "@ds/display/TextValue";

export interface EyebrowInput {
  children: ReactNode;
  /** Optional inline icon before the text. */
  icon?: ReactNode;
  /** Visual weight. Default `"default"`. */
  size?: "sm" | "default";
  className?: string;
  testId?: string;
}

export type EyebrowProps = EyebrowInput;

export function Eyebrow({
  children,
  icon,
  // Both sm and default map to `xs` (FONT_SIZE.label = 11) in the new scale.
  // The previous 10/11 px split is collapsed; eyebrow always uses xs.
  size: _size,
  className,
  testId,
}: EyebrowProps) {
  if (!icon) {
    return (
      <TextValue
        as="div"
        size="xs"
        weight="semibold"
        tone="muted"
        uppercase
        testId={testId}
        className={className}
      >
        {children}
      </TextValue>
    );
  }

  return (
    <Inline inline gap="xs" align="center" testId={testId} className={className}>
      {icon}
      <TextValue
        as="span"
        size="xs"
        weight="semibold"
        tone="muted"
        uppercase
      >
        {children}
      </TextValue>
    </Inline>
  );
}
